import { useState } from "react";
import { Loader2, KeyRound, Check } from "lucide-react";
import { toast } from "../../components/ui/sonner";
import { Card, PageTitle } from "../ui";
import { changeMyPassword } from "../../lib/adminP1Api";
import { useAuth } from "../AuthContext";

export default function AdminDefinicoesPage() {
  const { refresh } = useAuth();
  const [current, setCurrent] = useState("");
  const [novaA, setNovaA] = useState("");
  const [novaB, setNovaB] = useState("");
  const [loading, setLoading] = useState(false);
  const inputCls = "w-full rounded-xl bg-white border-2 border-[#1E5F6E]/10 px-4 py-3 text-sm focus:border-[#1E5F6E] focus:outline-none";

  const submit = async (e) => {
    e.preventDefault();
    if (novaA.length < 8) { toast.error("Password tem de ter pelo menos 8 caracteres."); return; }
    if (novaA !== novaB) { toast.error("As passwords não coincidem."); return; }
    setLoading(true);
    try {
      await changeMyPassword(current, novaA);
      toast.success("Password alterada com sucesso.");
      setCurrent(""); setNovaA(""); setNovaB("");
      refresh();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Não foi possível alterar.");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-definicoes">
      <PageTitle subtitle="Gerir as suas preferências.">Definições</PageTitle>
      <Card className="max-w-lg">
        <div className="flex items-center gap-2 mb-4">
          <KeyRound className="h-4 w-4 text-[#1E5F6E]" />
          <h2 className="font-display text-lg font-bold">Alterar password</h2>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="form-pw">
          <label className="block">
            <span className="text-sm font-semibold">Password atual</span>
            <input type="password" required data-testid="pw-current" className={inputCls + " mt-1"} value={current} onChange={(e) => setCurrent(e.target.value)} />
          </label>
          <label className="block">
            <span className="text-sm font-semibold">Nova password</span>
            <input type="password" required minLength={8} data-testid="pw-new-a" className={inputCls + " mt-1"} value={novaA} onChange={(e) => setNovaA(e.target.value)} />
          </label>
          <label className="block">
            <span className="text-sm font-semibold">Confirmar nova password</span>
            <input type="password" required minLength={8} data-testid="pw-new-b" className={inputCls + " mt-1"} value={novaB} onChange={(e) => setNovaB(e.target.value)} />
          </label>
          <button type="submit" disabled={loading} data-testid="pw-submit" className="inline-flex items-center gap-2 rounded-full bg-[#1E5F6E] text-white px-6 py-3 text-sm font-bold hover:bg-[#174E5B] disabled:opacity-40">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4" />}
            Guardar
          </button>
        </form>
      </Card>
    </div>
  );
}
